import { createContext } from 'react'

import type { DashboardElement } from '../../types/dashboard'

import type { Swapy } from 'swapy'

import type { AddElementArgs, HandleRowResizeArgs, RemoveElementArgs } from '../../utils/elementTree'

interface DashboardContextType {
  elements: DashboardElement[]
  setElements: React.Dispatch<React.SetStateAction<DashboardElement[]>>

  pendingUpdates: React.MutableRefObject<Map<string, { size: number; elementType: 'slot' | 'container' }>>
  updateTimeout: React.MutableRefObject<NodeJS.Timeout | null>

  isConfigurable: boolean
  setIsConfigurable: React.Dispatch<React.SetStateAction<boolean>>

  swapyRef: React.MutableRefObject<Swapy | null>

  resetDashboard: () => void
  resetKey: number

  handleAddTile: (args: AddElementArgs) => void
  handleRemoveTile: (args: RemoveElementArgs) => void
  handleRowResize: (args: HandleRowResizeArgs) => void
}

export const DashboardContext = createContext<DashboardContextType | undefined>(undefined)
